"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatNew = chatNew;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const chatNames_1 = require("./utils/chatNames");
const resolveThreadFolder_1 = require("./utils/resolveThreadFolder");
async function chatNew(input, deps) {
    // A chat has exactly two canonical homes: refs/chats, or {weave}/{thread}/chats.
    // Anything else — a weave with no resolvable thread, or no weave at all — is not
    // a valid chat location and MUST error rather than silently orphan an invalid,
    // tree-invisible file (the same "unresolvable reference → error, never fabricate"
    // invariant resolveThreadFolder enforces for doc-creates).
    let chatsDir;
    let scopeId;
    if (input.weaveSlug === 'refs') {
        chatsDir = path.join(deps.loomRoot, 'loom', 'refs', 'chats');
        scopeId = 'refs';
    }
    else if (input.weaveSlug && input.threadUlid) {
        const { threadSlug, threadPath } = await (0, resolveThreadFolder_1.resolveThreadFolder)(input.weaveSlug, input.threadUlid, {
            getActiveLoomRoot: () => deps.loomRoot, loadDoc: deps.loadDoc, fs: deps.fs,
        });
        chatsDir = path.join(threadPath, 'chats');
        scopeId = threadSlug;
    }
    else {
        throw new Error(`Cannot create chat: a chat lives only in a thread ({weave}/{thread}/chats) ` +
            `or in refs (refs/chats). Got weaveSlug='${input.weaveSlug ?? ''}' with no ` +
            `resolvable thread — pass the thread's th_ ULID as threadUlid, or target refs. ` +
            `A weave-root chat (loom/{weave}/chats) is not a valid location.`);
    }
    await deps.fs.ensureDir(chatsDir);
    const existingFiles = await deps.fs.readdir(chatsDir).catch(() => []);
    // Canonical flat chat filename: chat-NNN.md (ordinal recognises legacy names too).
    const ordinal = (0, dist_1.nextOrdinal)(existingFiles, 'chat');
    const chatFilename = (0, dist_1.chatFileName)(ordinal);
    const chatId = (0, dist_1.generateDocId)('chat');
    // Default title carries the same NNN as the filename so sibling default-named
    // chats under one thread stay distinct (chat-002.md → "{scope} Chat 002").
    const title = input.title || `${scopeId} Chat ${(0, dist_1.formatOrdinal)(ordinal)}`;
    const frontmatter = (0, dist_1.createBaseFrontmatter)('chat', chatId, title, null);
    const doc = {
        ...frontmatter,
        type: 'chat',
        status: 'active',
        content: `## ${(0, chatNames_1.getUserName)(deps.loomRoot)}\n`,
    };
    const filePath = path.join(chatsDir, chatFilename);
    await deps.saveDoc(doc, filePath);
    return { id: chatId, filePath };
}
